import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _QualityGarmentProperties, _QualityGarmentStandars, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { useEffect, useState } from "react";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";

interface componentData {
    QualityGarment: any
}

export const QualityGarmentStandars = ({ QualityGarment }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityGarmentStandars)

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Estandar", MODAL_SM);

    const head = [
        { title: 'ID', property: 'IDQualityGarmentStandars', visible: true },
        { title: 'Nombre del Estandar', property: 'MeasurementStandard', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ];

    useEffect(() => {
        if (QualityGarment?.IDQualityGarment) {
            getLista();
        }
    }, [QualityGarment?.IDQualityGarment])

    const getLista = () => {
        const props = {
            IDQualityGarment: QualityGarment?.IDQualityGarment,
            State: 1
        }
        instance.getQualityGarmentStandarsCatalogPorPropiedades(props, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDQualityGarment: QualityGarment?.IDQualityGarment,
        });
        modal.open("Agregar Estandar");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Estandar") } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityGarmentStandars(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [
            "MeasurementStandard", "Description",
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('MeasurementStandard') ? 'has-error' : ''}`} >Nombre del Estandar</label>
                            <input type="text" value={bean.MeasurementStandard} onChange={(e) => { setBean({ ...bean, MeasurementStandard: e.target.value }) }} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Description') ? 'has-error' : ''}`} >Descripción</label>
                            <textarea value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} className="form-control"/>
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}